import { create } from 'zustand'

import type { StickerPlacement } from '@renderer/lib/stickers/bakeStickers'

export type { StickerPlacement }

interface BkStickerState {
  placements: StickerPlacement[]
  add: (placement: StickerPlacement) => void
  clear: () => void
}

/**
 * Placements live here rather than in session state, matching `view/Edit.tsx`:
 * the stock editor keeps them local and bakes them into the output image, so
 * nothing downstream expects to find them on the session. Holding them in a
 * store instead of page state is what lets `select` re-render the same strip
 * without `edit` having to bake first — the bake belongs with printing.
 *
 * Cleared at the start of each session so one guest's stickers cannot appear on
 * the next guest's strip.
 */
export const useBkStickerStore = create<BkStickerState>((set) => ({
  placements: [],
  add: (placement): void => set((s) => ({ placements: [...s.placements, placement] })),
  clear: (): void => set({ placements: [] })
}))
